import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { config } from '../config/env';

export const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      navigate('/');
    }
  }, [authState, navigate]);

  const handleLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  return (
    <div className="centered full-height">
      <div className="card">
        <h1>{config.appName}</h1>
        <p className="muted">See which agents and MCP servers you have access to.</p>
        <button className="primary-button" onClick={handleLogin}>
          Sign in with Okta
        </button>
      </div>
    </div>
  );
};
